import { styled } from '../../Utilities';
import { CalloutContentBase } from './CalloutContent.base';
import { getStyles } from './CalloutContent.styles';
export var CalloutContent = styled(CalloutContentBase, getStyles, undefined, { scope: 'CalloutContent' });
//# sourceMappingURL=CalloutContent.js.map